module.exports = "/_next/static/media/4a3a70498e825061cc2f5de3fb37f613.png";